const FACEBOOK_GROUP = "https://www.facebook.com/A320Expert";
const LINKEDIN_GROUP = "https://www.linkedin.com/company/74811844/";
const SURVEY_URL = "https://forms.gle/KXHSNUDU1Qp3WmLj6";

export {
    FACEBOOK_GROUP, LINKEDIN_GROUP, SURVEY_URL
}